export default "__VITE_ASSET__29377a64__"